// Products data — 18 luxury access cards
// IDs map to videoMap, recommendations, telegramLinks
// Long-form content (description, features, howItWorks, bestFor) is base in EN
// and translatable via translations.products[lang][id] when available.

export const products = [
  {
    id: "foundation-group",
    name: "Foundation Group",
    rank: 4,
    importance: "primary",
    category: "guidedLearning",
    categoryLabel: "Guided Learning Group",
    level: ["Beginner"],
    format: ["Live Education", "Guided Sessions", "Support"],
    environment: "Private learning room",
    badges: ["Beginner Friendly", "Guided Path", "Support Included"],
    accent: "gold",
    image: "https://images.unsplash.com/photo-1761437855740-c894da924d79?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "room",
  },
  {
    id: "elite-learning-room",
    name: "Elite Learning Room",
    rank: 6,
    importance: "primary",
    category: "guidedLearning",
    categoryLabel: "Premium Educational Community",
    level: ["Intermediate", "Advanced"],
    format: ["Selective Education", "Advanced Commentary", "Module Preview"],
    environment: "Private premium room",
    badges: ["Premium Room", "Advanced", "Early Preview"],
    accent: "bronze",
    image: "https://images.unsplash.com/photo-1771226281605-f1e505ade901?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "lounge",
  },
  {
    id: "mirror-study-access",
    name: "Mirror Study Access",
    rank: 7,
    importance: "primary",
    category: "mirrorObservation",
    categoryLabel: "Observation Learning",
    level: ["Beginner", "Intermediate"],
    format: ["Allocation Education", "Risk Limits"],
    environment: "Observation dashboard",
    badges: ["Settings Education", "Less Manual", "Risk Limits"],
    accent: "cyan",
    image: "https://images.unsplash.com/photo-1760978632114-0939f0d60045?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "dashboard-bridge",
  },
  {
    id: "technical-indicator-lab",
    name: "Technical Indicator Lab",
    rank: 11,
    importance: "secondary",
    category: "manualAnalysis",
    categoryLabel: "Technical Study Tool",
    level: ["Intermediate", "Advanced"],
    format: ["Manual Confirmation"],
    environment: "Indicator dashboard",
    badges: ["Indicator Study", "Manual Context", "Technical Logic"],
    accent: "cyan",
    image: "https://images.unsplash.com/photo-1770745559994-545619d3c3da?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "compass",
  },
  {
    id: "otc-session-navigator",
    name: "OTC Session Navigator",
    rank: 12,
    importance: "secondary",
    category: "sessionSystems",
    categoryLabel: "Session Observation Tool",
    level: ["Beginner", "Intermediate"],
    format: ["Session Behavior Education"],
    environment: "Session dashboard",
    badges: ["Session Study", "Flexible Time", "Volatility Rhythm"],
    accent: "violet",
    image: "https://images.unsplash.com/photo-1761437855740-c894da924d79?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "radar",
  },
  {
    id: "pro-analysis-suite",
    name: "Pro Analysis Suite",
    rank: 13,
    importance: "secondary",
    category: "advancedAnalytics",
    categoryLabel: "Advanced Analysis Suite",
    level: ["Beginner", "Intermediate"],
    format: ["Market Overview", "Scenario Review"],
    environment: "Technical overview dashboard",
    badges: ["Structured Overview", "Scenario Cards", "Indicator Context"],
    accent: "cyan",
    image: "https://images.unsplash.com/photo-1771226281605-f1e505ade901?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "terminal",
  },
  {
    id: "binarex-assistant",
    name: "BinareX Assistant",
    rank: 14,
    importance: "secondary",
    category: "manualAnalysis",
    categoryLabel: "Educational Assistant",
    level: ["Beginner", "Intermediate"],
    format: ["Technical Explanation Assistant"],
    environment: "Assistant panel",
    badges: ["Assistant", "Explanation", "Beginner Friendly"],
    accent: "amber",
    image: "https://images.unsplash.com/photo-1760978632114-0939f0d60045?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "assistant",
  },
  {
    id: "evo-market-algorithm",
    name: "Evo Market Algorithm",
    rank: 8,
    importance: "primary",
    category: "advancedAnalytics",
    categoryLabel: "Multi-Market Educational Algorithm",
    level: ["Intermediate", "Advanced"],
    format: ["Multi-Market Observation"],
    environment: "Multi-market dashboard",
    badges: ["Multi-Market", "Flexible Study", "Advanced Logic"],
    accent: "emerald",
    image: "https://images.unsplash.com/photo-1770745559994-545619d3c3da?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "orb",
  },
  {
    id: "ultra-session-scanner",
    name: "Ultra Session Scanner",
    rank: 15,
    importance: "secondary",
    category: "sessionSystems",
    categoryLabel: "Advanced Session Scanner",
    level: ["Intermediate", "Advanced"],
    format: ["Fast Session Behavior Study"],
    environment: "Scanner dashboard",
    badges: ["Advanced Scanner", "Fast Context", "Session Focus"],
    accent: "cyan",
    image: "https://images.unsplash.com/photo-1761437855740-c894da924d79?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "scanner",
  },
  {
    id: "strategyx-lab",
    name: "StrategyX Lab",
    rank: 2,
    importance: "flagship",
    category: "advancedAnalytics",
    categoryLabel: "Advanced Strategy Lab",
    level: ["Advanced", "Pro"],
    format: ["Strategy-Based Analysis"],
    environment: "Strategy lab",
    badges: ["Strategy Library", "Advanced", "Pro Path"],
    accent: "gold",
    image: "https://images.unsplash.com/photo-1771226281605-f1e505ade901?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "engine",
    featured: true,
  },
  {
    id: "nexus-vision",
    name: "Nexus Vision",
    rank: 1,
    importance: "flagship",
    category: "advancedAnalytics",
    categoryLabel: "Flagship Educational Software",
    level: ["Advanced", "Pro"],
    format: ["Manual Study", "Scenario Simulation", "AI Assistant"],
    environment: "Flagship dashboard",
    badges: ["Flagship", "AI Assistant", "Manual + Scenario"],
    accent: "gold",
    image: "https://images.unsplash.com/photo-1770745559994-545619d3c3da?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "command-center",
    featured: true,
  },
  {
    id: "confluence-analysis-app",
    name: "Confluence Analysis App",
    rank: 16,
    importance: "secondary",
    category: "manualAnalysis",
    categoryLabel: "Manual Analysis App",
    level: ["Intermediate", "Advanced"],
    format: ["Confluence Explanation", "Technical Context"],
    environment: "Confluence dashboard",
    badges: ["Confluence", "Deep Explanation", "Technical Context"],
    accent: "violet",
    image: "https://images.unsplash.com/photo-1760978632114-0939f0d60045?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "prism",
  },
  {
    id: "pocket-era",
    name: "Pocket Era",
    rank: 17,
    importance: "secondary",
    category: "manualAnalysis",
    categoryLabel: "Telegram Mini-App Learning Interface",
    level: ["Beginner", "Intermediate"],
    format: ["Mobile-First Education", "Strategy Learning"],
    environment: "Telegram mini-app",
    badges: ["Mini-App", "Courses", "Mobile First"],
    accent: "cyan",
    image: "https://images.unsplash.com/photo-1761437855740-c894da924d79?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "phone-app",
  },
  {
    id: "vertex-mt5-lab",
    name: "Vertex MT5 Lab",
    rank: 9,
    importance: "primary",
    category: "advancedAnalytics",
    categoryLabel: "MT5 Educational Lab",
    level: ["Advanced", "Pro"],
    format: ["Real-Market Structure Education"],
    environment: "MT5-style educational terminal",
    badges: ["MT5 Style", "Risk Levels", "Advanced"],
    accent: "amber",
    image: "https://images.unsplash.com/photo-1771226281605-f1e505ade901?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "terminal-pro",
  },
  {
    id: "quant-research-algorithm",
    name: "Quant Research Algorithm",
    rank: 3,
    importance: "flagship",
    category: "advancedAnalytics",
    categoryLabel: "Quant Research Core",
    level: ["Advanced"],
    format: ["Automated Scenario Research", "Risk-Setting Simulation"],
    environment: "Research core dashboard",
    badges: ["Quant Core", "Research", "Risk Settings"],
    accent: "gold",
    image: "https://images.unsplash.com/photo-1770745559994-545619d3c3da?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "research-core",
    featured: true,
  },
  {
    id: "individual-learning-session",
    name: "Individual Learning Session",
    rank: 10,
    importance: "primary",
    category: "guidedLearning",
    categoryLabel: "Personal Mentoring",
    level: ["Beginner", "Intermediate", "Advanced"],
    format: ["1-on-1 Educational Session"],
    environment: "Private learning session",
    badges: ["1-on-1", "Personal", "Mentoring"],
    accent: "bronze",
    image: "https://images.unsplash.com/photo-1760978632114-0939f0d60045?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "mentor-room",
  },
  {
    id: "learning-access-code",
    name: "Learning Access Code",
    rank: 5,
    importance: "primary",
    category: "accessSupport",
    categoryLabel: "Access Code",
    level: ["All"],
    format: ["Educational Code Reveal", "Onboarding Instruction"],
    environment: "Private onboarding route",
    badges: ["Private Code", "Unlock Route", "Onboarding"],
    accent: "gold",
    image: "https://images.unsplash.com/photo-1761437855740-c894da924d79?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "scratch-card",
    featured: true,
  },
  {
    id: "private-support",
    name: "Private Support",
    rank: 18,
    importance: "secondary",
    category: "accessSupport",
    categoryLabel: "Support / Onboarding",
    level: ["All"],
    format: ["Telegram Support", "Access Guidance"],
    environment: "Private onboarding",
    badges: ["Support", "Onboarding", "Guidance"],
    accent: "cyan",
    image: "https://images.unsplash.com/photo-1771226281605-f1e505ade901?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    visual: "support-desk",
  },
];

export const productById = (id) => products.find((p) => p.id === id);

export const featuredIds = [
  "nexus-vision",
  "strategyx-lab",
  "quant-research-algorithm",
  "foundation-group",
  "learning-access-code",
  "elite-learning-room",
];
